'use client';

import { usePathname } from 'next/navigation';

// the html sitemaps, by exact route shape, so a user-named entry, profile or account never matches
const HTML_SITEMAP_PATH =
  /^(\/[^/]+)?\/(sitemap\.html|sitemap\/base\.html|(entry|profiles)\/sitemap\.html\/[^/]+)$/;

export default function Template({ children }: { children: React.ReactNode }) {
  // FIXME: change to using cit context provider to get whether we're in iframe mode once thats added
  const pathname = usePathname();
  const isIframeRoute = pathname?.startsWith('/iframe');

  // if route is an iframe route, don't wrap in layout-container, which adds space at top for nav bar, not needed for iframe
  if (isIframeRoute) {
    return <div className='iframe-layout-container'>{children}</div>;
  }

  // the html sitemaps render no navbar, so they get none of its spacing
  if (HTML_SITEMAP_PATH.test(pathname ?? '')) {
    return <>{children}</>;
  }

  return <div className='layout-container'>{children}</div>;
}
